// Canonical source: utilitybelt/blueprints/stripe/config.py and coin.py.
// If you change these values, update utilitybelt in lockstep — the backend
// awards coins from the Stripe webhook and must agree with what we quote here.
// premium.test.js mirrors utilitybelt/blueprints/stripe/tests/test_coin.py so
// either side drifting fails CI.
const STRIPE_CUT_PERCENT = 3.5;
const STRIPE_CLIMATE_CUT_PERCENT = 0.1;
const STRIPE_BASE_FEE_CENTS = 32;
const CENTS_TO_COINS = 0.35;
const PREMIUM_COIN_MULTIPLIER = 2;

const getStripeCut = (donation_cents) => {
  return Math.ceil((donation_cents * STRIPE_CUT_PERCENT) / 100);
};

const getClimateCut = (donation_cents) => {
  return Math.ceil((donation_cents * STRIPE_CLIMATE_CUT_PERCENT) / 100);
};

const convertDonationToCoinValue = ({ donation_cents, isPremium = false }) => {
  if (donation_cents < 0) {
    throw new Error('Negative donation');
  }
  if (donation_cents === 0) {
    return 0;
  }

  const netDonation =
    donation_cents -
    getStripeCut(donation_cents) -
    getClimateCut(donation_cents) -
    STRIPE_BASE_FEE_CENTS;

  if (netDonation <= 0) {
    return 0;
  }

  const coinValue = Math.floor(netDonation * CENTS_TO_COINS);
  return isPremium ? coinValue * PREMIUM_COIN_MULTIPLIER : coinValue;
};

// NOTE: Minimum/maximum donation is set in packages/site/src/utilities/stripe/config.js
const COIN_PRICES_FAKE = [
  {
    cents: 300,
    type: 'amount',
  },
  {
    cents: 500,
    type: 'amount',
  },
  {
    cents: 1000,
    type: 'amount',
  },
  {
    cents: 2500,
    type: 'amount',
  },
  {
    cents: 5000,
    type: 'amount',
  },
  {
    cents: 10000,
    type: 'amount',
  },
  {
    cents: 25000,
    type: 'amount',
  },
  {
    label: 'Upgrade to Premium',
    destination: '/premium',
    type: 'link',
    dropFor: ['premium'],
  },
];

const getCoinPrices = ({ isPremium = false }) => {
  const coinPrices = COIN_PRICES_FAKE.map((price) => {
    const label = price.label || `$${price.cents / 100}`;
    const id = price.cents || price.destination;
    const coins = price.cents
      ? convertDonationToCoinValue({ donation_cents: price.cents, isPremium })
      : null;

    return {
      ...price,
      coins,
      id,
      label,
    };
  });

  return coinPrices;
};

const getApproximatePeoplePerCoin = (coins) => {
  const peoplePerCoin = 0.5;
  return Math.round(coins * peoplePerCoin);
};

const convertCentsToPromoteQuantity = (cents) => {
  // convertDonationToCoinValue(cents) divided by 2, rounded down to the nearest 10
  return (
    Math.floor(convertDonationToCoinValue({ donation_cents: cents }) / 2 / 10) *
    10
  );
};

export {
  convertCentsToPromoteQuantity,
  convertDonationToCoinValue,
  getApproximatePeoplePerCoin,
  getCoinPrices,
};
